import { useAuditApi } from "./common/auditApi";

export function useDashboardAuditApi() {
  return useAuditApi({
    url: 'dashboard',
    translateTitle: (t) => t.audit.actions.fetchDashboard.title,
    translateError: (t) => t.audit.actions.fetchDashboard.error
  });
}
